import React, { useEffect, useRef, useState } from "react";

export const UiTooltip = ({
  triggerIcon,
  children,
  className,
  isOpen,
  setIsOpen,
}) => {
  const divRef = useRef(null);
  const [internalOpen, setInternalOpen] = useState(false);

  const open = isOpen !== undefined ? isOpen : internalOpen;
  const setOpen = setIsOpen !== undefined ? setIsOpen : setInternalOpen;

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={divRef} className={className}>
      <span onClick={() => setOpen(!open)}>{triggerIcon}</span>
      {open && children}
    </div>
  );
};
